import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceProfileService {

  private createDeviceProfileDetails = new BehaviorSubject("");
  currentData = this.createDeviceProfileDetails.asObservable();

  constructor() { }

  PassedData(message){
    this.createDeviceProfileDetails.next(message);
  }
}
